import { HttpClient } from '@angular/common/http';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var AnalyticsHttpService = /** @class */ (function () {
    function AnalyticsHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    /**
     * Normalize API response by extracting data from nested structure if needed
     * Handles responses that may be wrapped in a 'data' property
     */
    AnalyticsHttpService.prototype.normalizeApiResponse = function (response) {
        if (!response || typeof response !== 'object' || Array.isArray(response)) {
            return response;
        }
        var responseObj = response;
        // If response has labels and data at top level, use it directly
        if (responseObj.labels && responseObj.data) {
            return responseObj;
        }
        // If response has a data property that contains our object
        if (responseObj.data && typeof responseObj.data === 'object' && !Array.isArray(responseObj.data)) {
            var dataObj = responseObj.data;
            if (dataObj.labels && dataObj.data) {
                return responseObj.data;
            }
        }
        // Otherwise use response as-is
        return response;
    };
    /**
     * Get drink volume data broken down by the specified dimension
     * @param queryParams Filter parameters including breakdownBy, distributors, clients, etc.
     */
    AnalyticsHttpService.prototype.getDrinkVolume = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/drink-volume';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                // AWS Amplify API.get returns the response body directly when response: false
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching drink volume:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get drink volume breakdown by drink (for doughnut chart)
     * Returns percentage breakdown by drink type
     * @param queryParams Filter parameters (distributors, clients, campuses, machines, date range, etc.)
     */
    AnalyticsHttpService.prototype.getDrinkVolumeBreakdown = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/drink-volume-breakdown';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching drink volume breakdown:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get drink volume aggregated by machine
     * @param queryParams Filter parameters (distributors, clients, campuses, machines, date range, etc.)
     */
    AnalyticsHttpService.prototype.getDrinkVolumeByMachine = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/drink-volume-by-machine';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching drink volume by machine:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get drink volume breakdown by machine (for doughnut chart)
     * Returns percentage breakdown by machine
     * @param queryParams Filter parameters (distributors, clients, campuses, machines, date range, etc.)
     */
    AnalyticsHttpService.prototype.getDrinkVolumeMachineBreakdown = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/drink-volume-machine-breakdown';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching machine breakdown:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get product consumption data (in lbs) broken down by the specified dimension
     * @param queryParams Filter parameters including breakdownBy, distributors, clients, etc.
     */
    AnalyticsHttpService.prototype.getConsumption = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/consumption';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching consumption:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get consumption data over time (for line chart)
     * @param queryParams Filter parameters including avgBy, distributors, clients, etc.
     */
    AnalyticsHttpService.prototype.getConsumptionOverTime = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/consumption-over-time';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching consumption over time:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get projected consumption data (in lbs) for the forecast period
     * @param queryParams Filter parameters including forecastDays, breakdownBy, distributors, clients, etc.
     */
    AnalyticsHttpService.prototype.getForecastConsumption = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/forecast-consumption';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching forecast consumption:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get projected consumption over time (time series for forecast)
     * @param queryParams Filter parameters including forecastDays, distributors, clients, etc.
     */
    AnalyticsHttpService.prototype.getForecastConsumptionOverTime = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/forecast-consumption-over-time';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching forecast consumption over time:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get inventory projection over time for the forecast period
     * @param queryParams Filter parameters including forecastDays, distributors, clients, etc.
     */
    AnalyticsHttpService.prototype.getInventoryProjection = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/inventory-projection';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching inventory projection:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get stock-out risk data for all machines and products
     * @param queryParams Filter parameters including distributors, clients, machines, products, etc.
     */
    AnalyticsHttpService.prototype.getStockoutRisk = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/stockout-risk';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching stockout risk:', err);
                observer.error(err);
            });
        });
    };
    /**
     * Get machine stock-out risk heatmap data
     * @param queryParams Filter parameters including distributors, clients, machines, products, etc.
     */
    AnalyticsHttpService.prototype.getStockoutHeatmap = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/stockout-heatmap';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                var data = _this.normalizeApiResponse(response);
                observer.next(data);
            }).catch(function (err) {
                console.error('Error fetching stockout heatmap:', err);
                observer.error(err);
            });
        });
    };
    AnalyticsHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsHttpService_Factory() { return new AnalyticsHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: AnalyticsHttpService, providedIn: "root" });
    return AnalyticsHttpService;
}());
export { AnalyticsHttpService };
